import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { BrandSchema } from '../types/brandSchema';
import { getTyresBrandList } from '../services/GetTyresBrandList';
import { getDisksBrandList } from '../services/GetDisksBrandList';
import { getAkbBrandList } from '../services/GetAkbBrandList';
import { getOilsBrandList } from '../services/GetOilsBrandList';
import { getTruckTyresBrandList } from '../services/GetTruckTyresBrandList';
import { sortBrand } from '../helpers/sortBrand';
import { getKamaContent } from '../services/GetKamaContent';
import { getBrandKamaList } from '../services/GetBrandKamaList';
import { getBrandKumhoList } from '../services/GetBrandKumhoList';
import { getKumhoContent } from '../services/GetKumhoContent';
import { getBrandViattiList } from '../services/GetBrandViattiList';
import { getViattyContent } from '../services/GetViattyContent';

const initialState: BrandSchema = {
  brandListTyres: null,
  brandListDisks: null,
  brandListAkb: null,
  brandListOils: null,
  brandListTruckTyres: null,
  brandKamaContent: null,
  brandKumhoContent: null,
  brandViattiContent: null,
  brandListKama: null,
  brandListKumho: null,
  brandListViatti: null,
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.brand,
      };
    });
    builder.addCase(getTyresBrandList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListTyres = action.payload.sort(sortBrand);
      }
    });
    builder.addCase(getDisksBrandList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListDisks = action.payload.filter(brand => !!brand.thumb).sort(sortBrand);
      }
    });
    builder.addCase(getAkbBrandList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListAkb = action.payload.filter(brand => !!brand.thumb).sort(sortBrand);
      }
    });
    builder.addCase(getOilsBrandList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListOils = action.payload.sort(sortBrand);
      }
    });
    builder.addCase(getTruckTyresBrandList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListTruckTyres = action.payload;
      }
    });
    builder.addCase(getKamaContent.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandKamaContent = action.payload[0];
      }
    });
    builder.addCase(getKumhoContent.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandKumhoContent = action.payload[0];
      }
    });
    builder.addCase(getViattyContent.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandViattiContent = action.payload[0];
      }
    });
    builder.addCase(getBrandKamaList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListKama = action.payload;
      }
    });
    builder.addCase(getBrandKumhoList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListKumho = action.payload;
      }
    });
    builder.addCase(getBrandViattiList.fulfilled, (state, action) => {
      if (action.payload) {
        state.brandListViatti = action.payload;
      }
    });
  },
});

export const { actions: brandActions } = brandSlice;
